import type { IMessage } from '@dev-fast/types';

export interface GameMessagesStateModel {
  doubleMessages: IMessage[];
}

export const GAME_MESSAGES_INITIAL_STATE: GameMessagesStateModel = {
  doubleMessages: [],
};
